import React, { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import api, { arr } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";
import { TableSkeleton } from "@/components/common/Loading";
import Pagination from "@/components/common/Pagination";

const PAGE_LIMIT = 50;
const LEVEL = { info: "text-slate-500", success: "text-green-600", warning: "text-amber-600", error: "text-red-600" };

export default function AutomationLogs() {
  const [logs, setLogs] = useState(null);
  const [pagination, setPagination] = useState({ total: 0, page: 1, totalPages: 1 });
  const [page, setPage] = useState(1);

  const load = async (p = 1) => {
    const { data } = await api.get("/admin/automation-logs", { params: { page: p, limit: PAGE_LIMIT } });
    setLogs(arr(data?.data));
    setPagination({ total: data.total, page: data.page, totalPages: data.totalPages });
  };

  useEffect(() => { load(1); }, []);

  const handlePage = (p) => { setPage(p); load(p); };

  if (!logs) return <div className="space-y-6"><PageHeader title="Automation Logs" /><TableSkeleton /></div>;

  return (
    <div className="space-y-6">
      <PageHeader title="Automation Logs" subtitle="System activity and automation history" icon={Activity} />
      <div className="card-surface overflow-hidden p-0">
        <div className="overflow-x-auto scrollbar-thin">
          <table className="w-full min-w-[700px]">
            <thead><tr className="bg-slate-50 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">
              <th className="px-4 py-3">Time</th><th className="px-4 py-3">Action</th><th className="px-4 py-3">Module</th><th className="px-4 py-3">Details</th>
            </tr></thead>
            <tbody className="divide-y divide-slate-50">
              {logs.length === 0 && <tr><td colSpan={4} className="px-4 py-8 text-center text-sm text-slate-400">No logs yet</td></tr>}
              {logs.map((l, i) => (
                <tr key={l.id || l._id || i} className="text-sm">
                  <td className="px-4 py-3 text-slate-500">{new Date(l.createdAt).toLocaleString()}</td>
                  <td className={`px-4 py-3 font-medium ${LEVEL[l.level] || "text-slate-700"}`}>{(l.action || "").replace(/_/g, " ")}</td>
                  <td className="px-4 py-3 capitalize text-slate-600">{l.module}</td>
                  <td className="px-4 py-3 text-slate-600">{l.details || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="px-4 pb-4">
          <Pagination page={pagination.page} totalPages={pagination.totalPages} total={pagination.total} limit={PAGE_LIMIT} onPage={handlePage} />
        </div>
      </div>
    </div>
  );
}
